import { icons } from "../../assets/icons";

export const sidebarOptions = [
  {
    icon: icons.dashboardActive,
    title: "My Account",
    link: "/myaccount",
    showTo: ["Store", "L1", "L2", "Finance"],
  },
  {
    icon: icons.reconciliation,
    title: "Help Center",
    link: "/helpcenter",
    showTo: ["Store", "L1", "L2", "Finance"],
  },
  {
    icon: icons.signoutIcon,
    title: "Change Password",
    link: "/changepassword",
    showTo: ["Store", "L1", "L2", "Finance"],
  },
  {
    icon: icons.vouchers,
    title: "Sign Out",
    showTo: ["Store", "L1", "L2", "Finance"],
  },
];
